import { Paths } from "../interfaces";

export const sortByAlhabetical = <T>(property: (Paths<T, 3> & string), sort: 'asc' | 'desc' = 'asc') => {
  return (a: T, b: T) => {
    const resolvePath = (value: T) => {
      return property.split('.').reduce((prev, curr) => (prev as any)?.[curr], value) as string;
    };

    if (typeof resolvePath(a) !== 'string') {
      return 1;
    }

    const result = (resolvePath(a)).localeCompare(resolvePath(b));

    return sort === 'desc' ? -1 * result : result;
  }
}

export const sortByPosition = <T extends { position?: number } | undefined>(a: T, b: T) => {
  if (a?.position === b?.position) return 0;
  if (typeof a?.position !== 'number') return 1;
  if (typeof b?.position !== 'number') return -1;

  return a.position - b.position;
}